<template>
  <nav class="v-navbar">
    <div class="v-navbar-menu">
      <div class="v-navbar-start">
        <slot name="start" />
      </div>

      <div class="v-navbar-middle">
        <slot />
      </div>

      <div class="v-navbar-end">
        <slot name="end" />
      </div>
    </div>
  </nav>
</template>

<style>
.v-navbar {
  position: relative;
}

.v-navbar-menu {
  flex-grow: 1;
  flex-shrink: 0;
  border-bottom: var(--border);
}

.v-navbar-start {
  justify-content: flex-start;
  margin-right: auto;
}

.v-navbar-middle {
  justify-content: center;
  margin: auto;
}

.v-navbar-end {
  justify-content: flex-end;
  margin-left: auto;
}

.v-navbar,
.v-navbar-menu,
.v-navbar-start,
.v-navbar-middle,
.v-navbar-end {
  align-items: stretch;
  display: flex;
}
</style>
